import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 9l4 -4l4 4","key":"svg-0"}],["path",{"d":"M16 15l-4 4l-4 -4","key":"svg-1"}]]

/**
 * IconSelector
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItc2VsZWN0b3IiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTggOWw0IC00bDQgNCIgLz4KICA8cGF0aCBkPSJNMTYgMTVsLTQgNGwtNCAtNCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/selector
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconSelector = createReactComponent('outline', 'selector', 'Selector', __iconNode);

export default IconSelector;